import { Textarea, TextareaProps } from '@chakra-ui/react'
import React from 'react'

export const AutoResizeTextarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>((props, ref) => {
  return <Textarea ref={ref} autoresize={true} {...props} />
})

AutoResizeTextarea.displayName = 'AutoResizeTextarea'
